import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';

import { getVideosGroupedByIds } from 'shared/selectors/videos';

const ACTIONS = createAsyncActions('SERVER.CHANNEL.VIDEOS.REMOVE');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


function performRemove(id, videoIds, method) {
  return function (dispatch, getState) {
    if (videoIds.length === 0) {
      return Promise.resolve();
    }

    const videoByIds = getVideosGroupedByIds(getState());

    // need to update usage in lists - get base item ids
    const baseVideoIds = _(videoIds)
      .map(id => _.get(videoByIds[id], 'baseItemId'))
      .filter(id => id && videoByIds[id])
      .value();

    const params = { id, videoIds: [...videoIds, ...baseVideoIds] };

    dispatch(START(params));

    return vodAdapter.listItems[method](id, videoIds)
      .then(
        function (response) {
          dispatch(SUCCESS(params, response));
          return response;
        },

        function (response) {
          dispatch(FAIL({}, response, { analytics: { type: 'error', name: 'dashboard.channel.videos.remove' } }));
        }
      );
  };
}


export default function () {
  return performRemove(...arguments, 'remove');
}


export function removeByBaseItemId() {
  return performRemove(...arguments, 'removeByBaseItemId');
}




// WEBPACK FOOTER //
// ./src/dashboard/redux/server/actions/channel/videos/remove.js